import { render, staticRenderFns } from "./PlayStatus.vue?vue&type=template&id=d990f910&scoped=true"
import script from "./PlayStatus.vue?vue&type=script&lang=js"
export * from "./PlayStatus.vue?vue&type=script&lang=js"
import style0 from "./PlayStatus.vue?vue&type=style&index=0&id=d990f910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d990f910",
  null
  
)

export default component.exports